import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { fetchCurrentUserCartDetails } from "../../redux/actions/cartActions"
import { useNavigate, useParams } from "react-router-dom"
import { IMG, BASE_URL } from "../../constant"
import styles from '../../sass/cart.module.scss'

const CartDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.admin);
  const { cart, loader, errors } = useSelector((state) => state.cart);
  const navigate = useNavigate();

  useEffect(() => {
    if (token && id) {
      dispatch(fetchCurrentUserCartDetails({ token, id }));
    }
  }, [dispatch, token, id]);

  console.log("Cart Details", JSON.stringify(cart,0,2))

  
  const formattedDate = (dateString) => {
    // Format date: Sun, Apr 6, 2025
    if (!dateString) return "";
    const createdAt = new Date(dateString);
    console.log("FormattedDate", createdAt)
    return createdAt.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    })
  }

  const formattedTime = (dateString) => {
    // Format time: 06:33 PM
    if (!dateString) return "";
    const createdAt = new Date(dateString);
    return createdAt.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
  }

  return (
    <div>
        {loader && <p>Loading...</p>}
        {errors && (
            <p style={{ color: "red" }}>
                Error: {typeof errors === "string" ? errors : errors.message || JSON.stringify(errors)}
            </p>
        )}

        {!loader && !errors && cart && Array.isArray(cart.products) && (
            <div className="ContainerBox">
                <div className={`${styles.Details} ${styles.orderDetailsTable}`}>
                    <table>
                        <thead>
                        <tr>
                            <th>Item Summary</th>
                            <th>Qty</th>
                            <th>Price</th>
                            <th>Total Price</th>
                        </tr>
                        </thead>
                        <tbody>
                        {cart.products?.map((product) => (
                            <tr key={product.id}>
                            <td>
                                <div className={styles.productItem}>
                                <img src={ BASE_URL + product.image} alt={product.name}/> 
                                <span className="fs-sm">{product.name}</span>
                                </div>
                            </td>
                            <td>x{product.quantity}</td>
                            <td>₹{product.offer_price}</td>
                            <td>₹{product.offer_price * product.quantity}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        )}
    </div>
  );
};

export default CartDetails;
